export const MOBILE_S = 320;
export const MOBILE_M = 375;
export const MOBILE_L = 520;
export const TABLET = 767;
export const LAPTOP = 1024;
export const LAPTOP_L = 1440;
export const DESKTOP = 2560;
